import { GetterTree } from "vuex";
import { IAppState } from "./interface";
import { IStoreRootState } from "@/store/interface";

export default <GetterTree<IAppState, IStoreRootState>> {
	appKey: state => state.appKey,
	contentKey: state => state.contentKey
}